<template>
    <v-dialog
        v-model="dialog"
        max-width="960"
    >
        <v-card>
            <v-card-title class="headline">Assign Contact Request</v-card-title>

            <v-card-text>

                <v-select
                    label="Assign To"
                    :items="employee_choices"
                    v-model="assign_to_employee_ids"
                    multiple
                    chips
                />

      
                <v-textarea
                    label="Additional Message"
                    v-model="additional_message"
                />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="dialog = false;"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                    :disabled="!isValid()"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            organization_id: null,
            
            assign_to_employee_ids: null,
            assign_to_team_ids: null,

            dialog: false,

            additional_message: '',

            employee_choices: [],
            team_choices: [],
        }
    },

    methods: {
        showDialog(contact_request)
        {
            this.organization_id = contact_request.organization_id;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/organizations/employees/labels',
            
                'params' : {
                        'organization_id': this.organization_id,
                    },
            
                'on_success': (data) => {
                        this.dialog = true;

                        this.employee_choices = [];

                        for ( let i = 0; i < data.teams.length; i++ )
                        {
                            this.employee_choices.push({
                                'text': 'Team: '+data.teams[i].text,
                                'value': data.teams[i].value
                            });
                        }

                        for ( let i = 0; i < data.choices.length; i++ )
                        {
                            if ( data.choices[i].is_archived )
                                continue;

                            this.employee_choices.push({
                                'text': 'Team Member: '+data.choices[i].text,
                                'value': data.choices[i].value
                            });
                        }
                    },
            
                'on_error': 'Unable to list team members',
            });

           
            
        },

        isValid()
        {
            if ( this.assign_to_employee_ids == null || this.assign_to_employee_ids.length == 0 ) return false;
            return true;
        },


        onOk() {
            this.dialog = false;

            let assign_info = {
                'additional_message' : this.additional_message,
                'assign_to_employee_ids' : this.assign_to_employee_ids,
            };

            this.$emit('force-assign',assign_info);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>